<template>
  <div>กรุณากรอกข้อมูล <b>กำหนดขาดทุนไม่เกิน </b></div>
</template>

<script>
export default {
  name: "notification-template",
};
</script>
